module.exports = __webpack_public_path__ + "assets/img/icon6.212e392f.png";